import { DataShopTable } from "@okeys/shared-utils"

export const getPrestateres = (dataShop: DataShopTable) => {
  const prestateres = dataShop.prestateres
  const prestatereAdmin = dataShop.admins.filter(
    (admin) => admin.isPrestatere === true
  )
  const prestateresManager = dataShop.managers.filter(
    (manager) => manager.isPrestatere === true
  )
  return [...prestateres, ...prestatereAdmin, ...prestateresManager]
}
